import { useNavigate } from "react-router-dom";

import Datatable from "@components/datatable";
import StatusChip from "@components/ui-components/status-chip";
import LoadingButton from "@components/ui-components/loading-button";
import Select from "@components/ui-components/select";
import {
    CONTRACT_STATUS_LABEL,
    CONTRACT_STATUS_OPTIONS,
    CONTRACT_STATUS_TONE
} from "@panel/shared/contract/misc/constants";
import { contractStatusOf } from "@panel/shared/contract/misc/helpers";
import useContractTargets from "../hooks/use-contract-targets";
import { PLATFORM_LABEL } from "@src/utility/constants/panel/common";

// Every brand, with where its contract stands. The agreement itself is managed
// on the brand detail page's Contract tab, so each row leads there.
const BrandContract = () => {
    const {
        rows, pagination, loading, filters,
        handleFilterChange, handlePageChange, handlePerRowsChange
    } = useContractTargets();
    const navigate = useNavigate();

    const columns = [
        {
            Header  : "Brand",
            accessor: "name",
            Cell    : ({ value }) => <span className="font-medium text-gray-900">{value || "—"}</span>
        },
        {
            Header  : "Platform",
            accessor: "platform_name",
            Cell    : ({ value }) => <span className="text-gray-700">{PLATFORM_LABEL[value] || value || "—"}</span>
        },
        {
            Header  : "Publishers",
            accessor: "affiliate_count",
            Cell    : ({ value }) => <span className="text-gray-700">{value ?? 0}</span>
        },
        {
            Header  : "Contract",
            accessor: "contract_status",
            Cell    : ({ row }) => {
                const status = contractStatusOf(row);
                return <StatusChip tone={CONTRACT_STATUS_TONE[status]} label={CONTRACT_STATUS_LABEL[status]} />;
            }
        },
        {
            Header  : "",
            accessor: "_id",
            Cell    : ({ row }) => (
                <div className="flex items-center justify-end">
                    <LoadingButton
                        color="neutral"
                        size="xs"
                        text="Manage contract"
                        onClick={() => navigate(`/brands/details/${row._id}?tab=contract`)}
                        testId="manage-brand-contract" />
                </div>
            )
        }
    ];

    return (
        <>
            <div className="flex flex-wrap items-center gap-3">
                <Select
                    id="brand-contract-status-filter"
                    placeholder="Any contract status"
                    value={filters.contract_status || ""}
                    options={CONTRACT_STATUS_OPTIONS}
                    onChange={(contract_status) => handleFilterChange({ contract_status })} />
            </div>

            <div className="mt-4 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <Datatable
                    columns={columns}
                    data={rows}
                    loading={loading}
                    pagination={{ count: pagination.total, page: pagination.page, limit: pagination.limit }}
                    handlePageChange={handlePageChange}
                    handlePerRowsChange={handlePerRowsChange}
                    customNoData={<span className="text-sm text-muted">No brands found.</span>} />
            </div>
        </>
    );
};

export default BrandContract;
